import { IsavedExportSettingsDTO } from "../../../bulkexport/api";

export type FavouriteMapDTO = {
  id: number;
  objectType: FavouriteObjectType.Map;
  name: string;
  mark: {
    id: number;
    marks: Record<string, string[]>;
  };
  lastModified: string;
};

export type FavouriteSlideDTO = {
  id: number;
  objectType: FavouriteObjectType.Slide;
  name: string;
  mark: {
    id: number;
    reportId: string;
    marks: Record<string, string[]>;
  };
  lastModified: string;
};

export type FavouriteBulkDTO = {
  id: number;
  bulkExportSettings: IsavedExportSettingsDTO;
  lastModified: string;
  isSavedSetting: boolean;
};

export type FavouriteMapDraftDTO = {
  objectType: FavouriteObjectType.Map;
  name: string;
  mark: {
    marks: Record<string, string[]>;
  };
};
export type FavouriteSlideDraftDTO = {
  objectType: FavouriteObjectType.Slide;
  name: string;
  mark: {
    reportId: string;
    marks: Record<string, string[]>;
  };
};

export type FavouriteBulkDraftDTO = {
  id: number;
  lastModified?: string;
  savedBulkExportSettingsId?: number;
  bulkExportSettings: IsavedExportSettingsDTO;
};

export type FavouriteBulkSavedDraftDTO = {
  savedBulkExportSettingsId: number;
};

export enum FavouriteObjectType {
  Map = 1,
  Slide = 2,
  Bulk = 3,
}
